import { atomWithReset } from "jotai/utils";

const WELCOME_MEETING_DURATION_IN_MINUTES = 90;
const CONSULTING_DURATION_IN_MINUTES = 120;

interface WelcomeMeetingTimeSlot {
  start: string;
  end: string;
  groupVisitScheduleId?: number;
}

interface WelcomeMeetingForm {
  visitType: "presential" | "online" | "";
  selectedLocationCode: number;
  selectedLocationName: string;
  selectedLocationAddress: string;
  date: string;
  timeSlot: WelcomeMeetingTimeSlot | null;
  isRescheduling: boolean;
  /**
   * Marca que o membro já avançou para o fluxo de consultoria (passou da intro).
   * Usado para revelar o selo de consultoria na listagem só ao voltar para
   * trocar de unidade — não na primeira passagem pela seleção.
   */
  hasEnteredConsulting: boolean;
}

const welcomeMeetingAtom = atomWithReset<WelcomeMeetingForm>({
  visitType: "",
  selectedLocationCode: 0,
  selectedLocationName: "",
  selectedLocationAddress: "",
  date: "",
  timeSlot: null,
  isRescheduling: false,
  hasEnteredConsulting: false,
});

const isFormatStepComplete = (form: WelcomeMeetingForm): boolean => {
  return form.visitType !== "";
};

const isUnitStepComplete = (form: WelcomeMeetingForm): boolean => {
  return isFormatStepComplete(form) && form.selectedLocationCode !== 0;
};

const isScheduleStepComplete = (form: WelcomeMeetingForm): boolean => {
  return isUnitStepComplete(form) && form.date !== "" && form.timeSlot !== null;
};

export {
  welcomeMeetingAtom,
  isFormatStepComplete,
  isUnitStepComplete,
  isScheduleStepComplete,
  WELCOME_MEETING_DURATION_IN_MINUTES,
  CONSULTING_DURATION_IN_MINUTES,
};
export type { WelcomeMeetingForm, WelcomeMeetingTimeSlot };
